import { render, staticRenderFns } from "./BuyModal.vue?vue&type=template&id=f6159d64&scoped=true&"
import script from "./BuyModal.vue?vue&type=script&lang=js&"
export * from "./BuyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6159d64",
  null
  
)

export default component.exports